/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Contact Data
 */

import {FaFacebookF, FaInstagram}  from 'react-icons/fa';
import {
    MdLocationOn, 
    MdOutlineLocalPostOffice,
    MdPhoneInTalk,
    MdPublic } from 'react-icons/md'

export const CONTACT = {
    location: {
        icon: (<MdLocationOn />),
        text: 'Rua das Tílias 104 A Caramulo',
        gps: '40.572433, -8.172738'
    },
    email: {
        icon: (<MdOutlineLocalPostOffice />),
        text: 'geral@beecaramulo.pt',
        mailto: 'mailto:geral@beecaramulo.pt'
    },
    phone1: {
        icon: (<MdPhoneInTalk />),
        text: '+351 934 151 882',
        tel: 'tel:+351 934 151 882'
    },
    phone2: {
        icon: (<MdPhoneInTalk />),
        text: '+351 913 543 211',
        tel: 'tel:+913 543 211'
    },
    social: {
        icon: (<MdPublic />),
        facebook: (<FaFacebookF />),
        instagram: (<FaInstagram />)
    }
}